export const red = "#d32f2f";
export const yellow = "#ffb74d";
export const blue = "rgba(73, 144, 218,0.6)";
export const orange = "#f57c00";
